import { __awaiter } from "tslib";
import { CheckboxVisibility, MessageBarType, Stack, mergeStyleSets } from '@fluentui/react';
import React, { useState } from 'react';
import { useAppDispatch } from '../../store/app.store';
//import { GetWeekAggregatedBookedHours } from '../../Store/CommonSelector';
import { DataGrid } from '@verge-vcl-react/data-grid';
import { adjustMarginStyles, dataCellStyles, headerStyle, styles, } from './StickyFooterComponent.styles';
//import { useMasterData } from '../../Utils/ContextHelper';
import { Constants } from '../../../common/constants';
import { updateCSAProjectAssignmentForecast } from '../../store/Thunks/CSAProjectAssignmentForecastThunks';
import { dailyGrainDateListSelector } from '../../store/Slices/DateNavigationSlice';
import { useSelector } from 'react-redux';
import { assignmentDetailsSelector } from '../../store/Slices/AssignmentDetailsSlice';
import moment from 'moment';
import { clearGridCells, resetGridCells, selectGridCells, updateGridCells } from '../../store/Slices/GridCellSlice';
import { calculateBookedHours } from '../../../Utils/AvailabilityCalculationUtil';
import { RA_ADD_NOTIFICATION, RA_REMOVE_NOTIFICATION } from '../../store/Slices/MessageBarSlice';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import { v4 as uuidv4 } from 'uuid';
import { TelemetryService } from '../../services/TelemetryService';
import { EventCodes, TelemetryActions, TelemetryAppConstants } from '../../../common/TelemetryConstants';
export const StickyFooterComponent = ({ isPastView }) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useAppDispatch();
    const dateHeader = useSelector(dailyGrainDateListSelector);
    const dailyDateList = dateHeader;
    const telemetryService = TelemetryService.getInstance();
    const startDate = dateHeader[0];
    const endDate = dateHeader[dateHeader.length - 1];
    const assignmentDetails = useSelector(assignmentDetailsSelector);
    const useralias = assignmentDetails === null || assignmentDetails === void 0 ? void 0 : assignmentDetails.resourceAlias;
    const cellDetails = useSelector(selectGridCells);
    const bookingdata = calculateBookedHours(assignmentDetails, dailyDateList, cellDetails); // Placeholder for actual booking data
    //const {profileDetails, isProfileDetailsLoaded} = useMasterData();
    const numberOfWorkingHours = 8; //TODO: Replace with actual logic to get number of working hours
    const totalAvailableHours = bookingdata.reduce((acc, curr) => acc + Math.max(0, numberOfWorkingHours - curr.bookedHours), 0);
    const totalBookedHours = bookingdata.reduce((acc, curr) => acc + Math.round(curr.bookedHours), 0);
    let updatedAssignmentsForecastData = [];
    let updatedSchedules = [];
    let gridCellsUpdated = [];
    const createRequestObject = () => {
        var _a;
        updatedAssignmentsForecastData = [];
        (_a = assignmentDetails === null || assignmentDetails === void 0 ? void 0 : assignmentDetails.eventDetails) === null || _a === void 0 ? void 0 : _a.forEach((event) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            if (event.eventCategory.toLowerCase() === 'project' && ((_a = event.customProperties) === null || _a === void 0 ? void 0 : _a.ResourceRequestStatusEnum) == "Assigned") {
                dailyDateList.forEach((date) => {
                    var _a, _b, _c;
                    let cellData = cellDetails.find((cell) => {
                        var _a;
                        return cell.rowId === String((_a = event.customProperties) === null || _a === void 0 ? void 0 : _a.ResourceRequestId) && cell.columnId === date;
                    });
                    if (cellData && cellData.currValue !== cellData.prevValue) {
                        updatedSchedules.push({ forecastDate: new Date(date), hours: cellData.currValue });
                        gridCellsUpdated.push({
                            rowId: String((_a = event.customProperties) === null || _a === void 0 ? void 0 : _a.ResourceRequestId),
                            columnId: date,
                            currValue: cellData.currValue,
                            prevValue: cellData.prevValue,
                            isSaving: false,
                            isNewlyUpdated: true,
                            isInputDirty: false,
                            valuePostUpdate: cellData.currValue
                        });
                    }
                    else {
                        let scheduleOnADay = (_c = (_b = event.customProperties) === null || _b === void 0 ? void 0 : _b.Schedules) === null || _c === void 0 ? void 0 : _c.filter((schedule) => {
                            const dateMoment = moment(schedule.forecastDate).format(Constants.DATE_FORMAT);
                            return dateMoment === date;
                        });
                        updatedSchedules.push({ forecastDate: new Date(date), hours: scheduleOnADay && (scheduleOnADay === null || scheduleOnADay === void 0 ? void 0 : scheduleOnADay.length) > 0 ? scheduleOnADay[0].durationInHours : 0 });
                    }
                });
                const assignmentObj = Object.assign(Object.assign({ assignmentID: (_b = event.customProperties) === null || _b === void 0 ? void 0 : _b.ResourceRequestId, requestedStartDate: moment.utc((_c = event.customProperties) === null || _c === void 0 ? void 0 : _c.RequestedStartDate).startOf('day').toDate(), requestedEndDate: moment.utc((_d = event.customProperties) === null || _d === void 0 ? void 0 : _d.RequestedEndDate).endOf('day').toDate(), requestedHours: (_e = event.customProperties) === null || _e === void 0 ? void 0 : _e.RequestedDurationInHours, offeringId: (_f = event.customProperties) === null || _f === void 0 ? void 0 : _f.OfferingId, contractExpiryDate: (_g = event.customProperties) === null || _g === void 0 ? void 0 : _g.ContractExpiryDate, isVBD: String((_h = event.customProperties) === null || _h === void 0 ? void 0 : _h.IsVBD).toLowerCase() === 'true', isFlexiDateRequest: String((_j = event.customProperties) === null || _j === void 0 ? void 0 : _j.IsFlexiDateRequest).toLowerCase() === 'true', forecastHours: updatedSchedules }, (((_k = event.customProperties) === null || _k === void 0 ? void 0 : _k.ProjectStartDate) && { projectStartDate: (_l = event.customProperties) === null || _l === void 0 ? void 0 : _l.ProjectStartDate })), (((_m = event.customProperties) === null || _m === void 0 ? void 0 : _m.ProjectEndDate) && { projectEndDate: (_o = event.customProperties) === null || _o === void 0 ? void 0 : _o.ProjectEndDate }));
                updatedAssignmentsForecastData.push(assignmentObj);
                updatedSchedules = [];
            }
        });
    };
    let availableHoursColumnData = [
        {
            styles: mergeStyleSets(headerStyle, adjustMarginStyles),
            key: 'Total Available Hours',
            name: 'Total Available ' + totalAvailableHours.toString() + ' hours',
            fieldName: 'rowName',
            type: 'primaryText',
            isResizable: false,
            ariaLabel: 'Available Hours Data',
            minColumnWidth: 450,
            maxWidth: 470,
        },
    ];
    let bookedHoursColumnData = [
        {
            styles: mergeStyleSets(headerStyle, adjustMarginStyles),
            key: 'Total Actual Hours',
            name: 'Total Actuals ' + totalBookedHours.toString() + ' hours',
            fieldName: 'rowName',
            type: 'primaryText',
            isResizable: false,
            ariaLabel: 'Total Actual Hours Data',
            minColumnWidth: 450,
            maxWidth: 470,
        },
    ];
    bookingdata.forEach((hours, index) => {
        availableHoursColumnData.push({
            styles: mergeStyleSets(dataCellStyles, adjustMarginStyles),
            key: hours.dailyDate.toString(),
            name: Math.max(0, numberOfWorkingHours - hours.bookedHours).toString(),
            fieldName: 'rowName',
            type: 'primaryText',
            isResizable: false,
            ariaLabel: 'Available Hours Data',
            maxWidth: 140,
        });
        bookedHoursColumnData.push({
            styles: mergeStyleSets(dataCellStyles, adjustMarginStyles),
            key: hours.dailyDate.toString(),
            name: Math.round(hours.bookedHours).toString(),
            fieldName: 'rowName',
            type: 'primaryText',
            isResizable: false,
            ariaLabel: 'Total Hours Data',
            maxWidth: 140,
        });
    });
    // Remove showButtons state, use isAnyCellDirty for button enable/disable
    const isAnyCellDirty = cellDetails && cellDetails.some(cell => cell.isInputDirty);
    // Find all assignment rowIds where IsFlexiDateRequest is false
    const nonFlexiRowIds = React.useMemo(() => {
        if (!(assignmentDetails === null || assignmentDetails === void 0 ? void 0 : assignmentDetails.eventDetails))
            return [];
        return assignmentDetails.eventDetails
            .filter(event => { var _a; return String((_a = event.customProperties) === null || _a === void 0 ? void 0 : _a.IsFlexiDateRequest).toLowerCase() === 'false'; })
            .map(event => { var _a; return String((_a = event.customProperties) === null || _a === void 0 ? void 0 : _a.ResourceRequestId); });
    }, [assignmentDetails]);
    // Check if any dirty cell belongs to a non-flexi assignment
    const hasNonFlexiDirtyCell = cellDetails && cellDetails.some(cell => cell.isInputDirty && nonFlexiRowIds.includes(cell.rowId));
    // Show warning if user updates a gridcell for a non-flexi assignment
    React.useEffect(() => {
        if (hasNonFlexiDirtyCell) {
            dispatch(RA_ADD_NOTIFICATION({
                id: "NonFlexiWarning",
                message: 'Warning: This Request has fixed Start and End Dates. Please confirm any changes with the CSAM before editing',
                show: true,
                messageBarType: MessageBarType.warning
            }));
        }
        else {
            // Remove the warning notification by resetting the notification state
            dispatch(RA_REMOVE_NOTIFICATION("NonFlexiWarning"));
        }
    }, [hasNonFlexiDirtyCell, dispatch]);
    return (!isPastView) ? (React.createElement(React.Fragment, null,
        isLoading && (React.createElement(LoaderComponent, { primaryText: "Updating Assignment schedules" })),
        React.createElement(Stack, null,
            React.createElement(Stack, { horizontal: true, style: { position: 'sticky', bottom: 0, zIndex: 5, backgroundColor: 'white', boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)' } },
                React.createElement("div", { style: { marginRight: '6px', marginLeft: '16px', alignSelf: 'center', display: 'flex', alignItems: 'center', height: '100%' } },
                    React.createElement("button", { type: "button", style: {
                            height: '35px',
                            background: isAnyCellDirty ? '#0078d4' : '#c8c6c4',
                            color: isAnyCellDirty ? 'white' : '#888',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '0 7px',
                            fontSize: '16px',
                            cursor: isAnyCellDirty ? 'pointer' : 'not-allowed',
                            display: 'flex',
                            alignItems: 'center',
                            marginRight: '8px',
                            minWidth: '65px',
                            opacity: isAnyCellDirty ? 1 : 0.6,
                        }, disabled: !isAnyCellDirty || isLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            if (!isAnyCellDirty)
                                return;
                            // Log telemetry for Submit button click
                            telemetryService.logEvent(EventCodes.Ev0005, 'User clicked Submit button in edit availability', TelemetryActions.UserAction);
                            setIsLoading(true);
                            createRequestObject();
                            const response = yield dispatch(updateCSAProjectAssignmentForecast({
                                resourceAlias: useralias,
                                startDate: new Date(startDate),
                                endDate: new Date(endDate),
                                assignmentDetails: updatedAssignmentsForecastData
                            }));
                            if (!response) {
                                setIsLoading(false);
                                telemetryService.logEvent(EventCodes.Ev0007, TelemetryActions.UserAction, 'Resource Assignment Forecast Updated From Esxp', {
                                    AppId: TelemetryAppConstants.AppId,
                                    ParentAppId: TelemetryAppConstants.ParentAppId,
                                    UPN: useralias,
                                    Channel: 'ESXP',
                                    Timestamp: new Date().toISOString(),
                                    ResultCode: 'Failed',
                                    AiInitiativeName: 'Availability Agent',
                                    IsAllowListed: true
                                }, null, false);
                                dispatch(RA_ADD_NOTIFICATION({
                                    id: uuidv4(),
                                    message: 'Submission failed.',
                                    show: true,
                                    messageBarType: MessageBarType.error
                                }));
                                return;
                            }
                            if (response.status === 400) {
                                setIsLoading(false);
                                let errorMsg = '';
                                // Check for failedRequestIds in response
                                if (response.data && response.data.failedRequestIds && response.data.failedRequestIds.length > 0) {
                                    // Only update grid for successful records
                                    const failedIds = response.data.failedRequestIds.map(String);
                                    const successfulGridCells = gridCellsUpdated.filter((cell) => !failedIds.includes(cell.rowId));
                                    telemetryService.logEvent(EventCodes.Ev0007, TelemetryActions.UserAction, 'Resource Assignment Forecast Updated From Esxp', {
                                        AppId: TelemetryAppConstants.AppId,
                                        ParentAppId: TelemetryAppConstants.ParentAppId,
                                        UPN: useralias,
                                        Channel: 'ESXP',
                                        Timestamp: new Date().toISOString(),
                                        ResultCode: 'Failed',
                                        AiInitiativeName: 'Availability Agent',
                                        IsAllowListed: true
                                    }, null, false);
                                    // Show partial failure notification
                                    dispatch(RA_ADD_NOTIFICATION({
                                        id: uuidv4(),
                                        message: response.data.updateStatus || 'Some records failed to update.',
                                        show: true,
                                        messageBarType: MessageBarType.error
                                    }));
                                    if (successfulGridCells.length > 0) {
                                        dispatch(updateGridCells(successfulGridCells));
                                    }
                                    // dispatch(clearGridCells());
                                    return;
                                }
                                else {
                                    telemetryService.logEvent(EventCodes.Ev0007, TelemetryActions.UserAction, 'Resource Assignment Forecast Updated From Esxp', {
                                        AppId: TelemetryAppConstants.AppId,
                                        ParentAppId: TelemetryAppConstants.ParentAppId,
                                        UPN: useralias,
                                        Channel: 'ESXP',
                                        Timestamp: new Date().toISOString(),
                                        ResultCode: 'Failed',
                                        AiInitiativeName: 'Availability Agent',
                                        IsAllowListed: true
                                    }, null, false);
                                    dispatch(RA_ADD_NOTIFICATION({
                                        id: uuidv4(),
                                        message: 'Error while submitting schedules.',
                                        show: true,
                                        messageBarType: MessageBarType.error
                                    }));
                                    return;
                                }
                            }
                            if (response.status === 200) {
                                setIsLoading(false);
                                dispatch(updateGridCells(gridCellsUpdated));
                                dispatch(clearGridCells());
                                telemetryService.logEvent(EventCodes.Ev0007, TelemetryActions.UserAction, 'Resource Assignment Forecast Updated From Esxp', {
                                    AppId: TelemetryAppConstants.AppId,
                                    ParentAppId: TelemetryAppConstants.ParentAppId,
                                    UPN: useralias,
                                    Channel: 'ESXP',
                                    Timestamp: new Date().toISOString(),
                                    ResultCode: 'Success',
                                    AiInitiativeName: 'Availability Agent',
                                    IsAllowListed: true
                                }, null, false);
                                dispatch(RA_ADD_NOTIFICATION({
                                    id: "SuccessfulUpdate",
                                    message: 'Schedules updated successfully.',
                                    show: true,
                                    messageBarType: MessageBarType.success
                                }));
                                setTimeout(() => {
                                    dispatch(RA_REMOVE_NOTIFICATION("SuccessfulUpdate"));
                                }, 4500);
                                return;
                            }
                            if (response.status === 204) {
                                setIsLoading(false);
                                dispatch(RA_ADD_NOTIFICATION({
                                    id: uuidv4(),
                                    message: 'No data to update.',
                                    show: true,
                                    messageBarType: MessageBarType.info
                                }));
                                return;
                            }
                            setIsLoading(false);
                        }) }, "Submit"),
                    React.createElement("button", { type: "button", style: {
                            height: '35px',
                            background: isAnyCellDirty ? '#f3f2f1' : '#e5e5e5',
                            color: '#323130',
                            border: '1px solid #c8c6c4',
                            borderRadius: '4px',
                            padding: '0 7px',
                            fontSize: '16px',
                            cursor: isAnyCellDirty ? 'pointer' : 'not-allowed',
                            display: 'flex',
                            alignItems: 'center',
                            opacity: isAnyCellDirty ? 1 : 0.6,
                        }, disabled: !isAnyCellDirty || isLoading, onClick: () => {
                            if (!isAnyCellDirty)
                                return;
                            // Log telemetry for Reset button click
                            telemetryService.logEvent(EventCodes.Ev0005, 'User clicked Reset button in edit availability', TelemetryActions.UserAction);
                            dispatch(resetGridCells());
                        } }, "Reset")),
                React.createElement("div", { style: {
                        width: '36px',
                        borderTop: '1px solid lightgrey',
                    } }),
                React.createElement(DataGrid, { styles: styles.stickyDataGridStyles, listConfig: availableHoursColumnData, data: [], checkboxVisibility: CheckboxVisibility.hidden, onRenderDetailsHeader: undefined }))))) : React.createElement(React.Fragment, null);
};
export default StickyFooterComponent;
//# sourceMappingURL=StickyFooterComponent.js.map